var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('h1',[_vm._v("404. Not Found")]),_c('p',[_vm._v("页面不存在")])])
}]

export { render, staticRenderFns }